// components/shared/ErrorMessage.js
// הצגת שגיאה עם אפשרות retry ו-dismiss
// שימוש:
//   <ErrorMessage error="תקלת שרת" />
//   <ErrorMessage error="אין חיבור" onRetry={refetch} />
//   <ErrorMessage error={error} onDismiss={() => setError(null)} />

import { Alert, AlertTitle, Button, Box } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';

export default function ErrorMessage({
  error,
  title = null,
  severity = 'error',
  onRetry = null,
  onDismiss = null,
  sx = {},
}) {
  const { t } = useTranslation();

  if (!error) return null;

  return (
    <Alert
      data-testid="shared__error-message"
      severity={severity}
      onClose={onDismiss || undefined}
      sx={{ mb: 2, ...sx }}
      action={
        onRetry ? (
          <Button
            data-testid="shared__error-message__button--retry"
            color="inherit"
            size="small"
            startIcon={<RefreshIcon />}
            onClick={onRetry}
          >
            {t('emptyStates.tryAgain')}
          </Button>
        ) : undefined
      }
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {error}
    </Alert>
  );
}
